import styled from "styled-components";

export type InternalOnlyTone = "gold" | "violet" | "dark";

const TONE = {
  gold: {
    height: "18px",
    padding: "0 7px",
    background: "rgba(196, 181, 143, 0.18)",
    border: "1px solid rgba(196, 181, 143, 0.45)",
    color: "#dcc49c",
    fontSize: "9px",
    letterSpacing: "0.11em",
  },
  violet: {
    height: "19px",
    padding: "0 7px",
    background: "rgba(179, 155, 236, 0.18)",
    border: "none",
    color: "#c3b0f2",
    fontSize: "9.5px",
    letterSpacing: "0.08em",
  },
  // the spec's .intonly.dark — the variant it draws on a light surface
  dark: {
    height: "18px",
    padding: "0 7px",
    background: "#f3efe4",
    border: "1px solid #dccba4",
    color: "#8a6d28",
    fontSize: "9px",
    letterSpacing: "0.11em",
  },
} as const;

export const InternalOnlyChip = styled.span<{ $tone?: InternalOnlyTone }>`
  flex: 0 0 auto;
  display: inline-flex;
  align-items: center;
  border-radius: 2px;
  font-weight: 600;
  text-transform: uppercase;
  ${({ $tone = "light" }) => {
    const t = TONE[$tone];
    return `
      height: ${t.height};
      padding: ${t.padding};
      background: ${t.background};
      border: ${t.border};
      color: ${t.color};
      font-size: ${t.fontSize};
      letter-spacing: ${t.letterSpacing};
    `;
  }}
`;
